import styled from "styled-components";

export const Wrapper = styled.main`
    background-color: var(--color-grey-1);
    border-top: 1px solid var(--color-grey-4);
    overflow: clip;

    @supports not (overflow: clip) {
        overflow: hidden;
        overflow-y: auto;
    }
`;
